export default __webpack_public_path__ + "static/media/wallet.2e96d73e.svg";